import { isArray } from 'lodash';
import { ImageKeywordModel } from './image-keyword.model';
import { ImageMetadataApiModel } from '../../../api/mentions/model/image-metadata.api.model';
import { basicClone, Clonable } from '../../Basic/decorators/clone.decorator';

export class ImageMetadataModel {
    @Clonable()
    keywords: ImageKeywordModel[];

    constructor(apiEntities?: ImageMetadataApiModel[]) {
        if (apiEntities && isArray(apiEntities)) {
            this.keywords = apiEntities.map(entity => new ImageKeywordModel(entity));
        } else {
            this.keywords = [];
        }
    }

    toApiEntity(): ImageMetadataApiModel[] {
        return this.keywords.map((keyword) => {
            return keyword.toApiEntity();
        });
    }

    clone(): ImageMetadataModel {
        return basicClone(this);
    }
}
